import { Form, InputNumber, Radio } from 'antd'
import { failureMessage } from 'api/global'
import { useAddGameResult } from 'api/league/leagueResult/leagueResult'
import CustomAvatar from 'components/global/CustomAvatar'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { leagueGamesStore } from 'state/league/leageGames'
import { myStore } from 'state/store'

const EnterScore: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { addScoreModal, setAddScoreModal, selectedGame } = leagueGamesStore(
    store => ({
      addScoreModal: store.addScoreModal,
      setAddScoreModal: store.setAddScoreModal,
      selectedGame: store.selectedGame,
    }),
  )
  const setModalBtnLoader = myStore(state => state.setModalBtnLoader)

  const closeModal = () => {
    setAddScoreModal(false)
  }

  const { mutate: addGameResult } = useAddGameResult()

  const handleFinish = (values: any) => {
    if (
      !selectedGame.leagueId ||
      !selectedGame._id ||
      !selectedGame.homeTeam._id ||
      !selectedGame.awayTeam._id
    ) {
      return failureMessage('Something went wrong, frontend error')
    }

    if (
      values.team1 === undefined ||
      values.team1 === null ||
      values.team2 === undefined ||
      values.team2 === null
    ) {
      return failureMessage('Team 1 and team 2 scores are required')
    }

    const payload = {
      leagueId: selectedGame.leagueId,
      gameId: selectedGame._id,
      homeTeamId: selectedGame.homeTeam._id,
      awayTeamId: selectedGame.awayTeam._id,
      homeTeamScore: values.team1,
      awayTeamScore: values.team2,
      notes: values.notes,
    }

    setModalBtnLoader(true)

    addGameResult(payload, {
      onSuccess: () => {
        setAddScoreModal(false)
        setModalBtnLoader(false)
      },
      onError: () => {
        setModalBtnLoader(false)
      },
    })
  }

  const handleValuesChange = (_, allValues: any) => {
    const team1 = Number(allValues?.team1)
    const team2 = Number(allValues?.team2)

    if (!Number.isNaN(team1) && !Number.isNaN(team2)) {
      if (team1 > team2) {
        form.setFieldsValue({ winner: 'team1' })
      } else if (team2 > team1) {
        form.setFieldsValue({ winner: 'team2' })
      } else {
        form.setFieldsValue({ winner: undefined })
      }
    } else {
      form.setFieldsValue({ winner: undefined })
    }
  }

  return (
    <CustomModal
      openModal={addScoreModal}
      isCloseModalCustom
      closeModal={closeModal}
      title="Enter score"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Save"
          closeModal={closeModal}
          onSubmit={handleSubmit}
        />
      }
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{}}
        onFinish={handleFinish}
        onValuesChange={handleValuesChange}
      >
        <Form.Item name="winner">
          <Radio.Group>
            <div className="flex align-center justify-between gap-20px">
              <div className="flex align-center gap-10px -mt-10px">
                <CustomAvatar
                  size={40}
                  src={selectedGame.homeTeam.team.profilePhoto?.thumb}
                  name={selectedGame.homeTeam.team.name}
                />
                <h3 className="text-14 w-500">
                  {selectedGame.homeTeam.team.name}
                </h3>
              </div>
              <div className="flex align-center gap-20px">
                <Form.Item name="team1" className="mb-10px">
                  <InputNumber
                    min={0}
                    placeholder="0"
                    className="br-12 w-130px"
                    onWheel={e => e.currentTarget.blur()}
                  />
                </Form.Item>
                <Radio value="team1" className="radio -mt-13px">
                  Winner
                </Radio>
              </div>
            </div>

            <div className="flex align-center justify-between gap-20px">
              <div className="flex align-center gap-10px -mt-10px">
                <CustomAvatar
                  size={40}
                  src={selectedGame.awayTeam.team.profilePhoto?.thumb}
                  name={selectedGame.awayTeam.team.name}
                />
                <h3 className="text-14 w-500">
                  {selectedGame.awayTeam.team.name}
                </h3>
              </div>
              <div className="flex align-center gap-20px">
                <Form.Item name="team2" className="mb-10px">
                  <InputNumber
                    min={0}
                    placeholder="0"
                    className="br-12 w-130px"
                    onWheel={e => e.currentTarget.blur()}
                  />
                </Form.Item>
                <Radio value="team2" className="radio -mt-13px">
                  Winner
                </Radio>
              </div>
            </div>
          </Radio.Group>
        </Form.Item>
      </Form>
    </CustomModal>
  )
}

export default EnterScore
